import React, { useState, useEffect, useRef } from "react"
import Modal from "react-modal"
import type { Annonce } from "../../models/AnnonceModel"
import LoaderAnnonce from "../../components/LoaderAnnonce"
import { getAllAnnoncesUser } from "../../services/Annonce_service"
import { createAvoir } from "../../services/Avoir_service"
import "../../styles/listeAnnonce.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEllipsisV,
  faEnvelope,
  faPaperPlane,
  faFile,
  faTimes,
  faEdit,
  faPlus,
} from "@fortawesome/free-solid-svg-icons"
import { ToastContainer, toast } from "react-toastify"
import { sendAttestationAloByEmail, sendJustifByEmail } from "../../services/Mail_service"
import UpdateAnnonce from "./annonce/UpdateAnnonce"
import useAppContext from "../../hooks/useAppContext"
import type { AppContextType } from "../../context/AppContext"
import axios from "../../api/axios"
import { FaCheckCircle, FaListAlt, FaCalculator } from "react-icons/fa"
import { paginate, ITEMS_PER_PAGE } from '../../utils/functions/pagination'
import { PaginationControls } from '../../components/PaginationControls'
import AnnonceDetailsAdmin from "./AnnonceDetailsAdmin"
import { DatePicker, Popover, Button } from "antd"
import dayjs from "dayjs"
import EmailReminderModal from "../../components/gestion-annonce/EmailReminderModal"
import AdminReminderModal from "./relance/AdminReminderModal"
import UserLimitCards from "./UserLimitCard"
import EmailModal from "./EmailModal"

const ListesAnnonces: React.FC = () => {
  const { setCurrentAnnonceId } = useAppContext() as AppContextType

  const [annonces, setAnnonces] = useState<Annonce[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [searchText, setSearchText] = useState<string>("")
  const [searchSupport, setSearchSupport] = useState<string>("")
  const [searchClient, setSearchClient] = useState<string>("")
  const [annonceNow, setAnnonceNow] = useState<Annonce | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [annonce, setAnnonce] = useState<{ [key: string]: string }>({})

  const [avoirModalIsOpen, setAvoirModalIsOpen] = useState<boolean>(false)
  const [selectedAnnonceForAvoir, setSelectedAnnonceForAvoir] = useState<Annonce | null>(null)
  const [avoirMontant, setAvoirMontant] = useState<string>("")
  const [avoirLoading, setAvoirLoading] = useState<boolean>(false)
  const [startDate, setStartDate] = useState<string | null>(null)
  const [endDate, setEndDate] = useState<string | null>(null)
  const [showFilterMenu, setShowFilterMenu] = useState(false)
  const [filterPaid, setFilterPaid] = useState<"all" | "paid" | "unpaid">("all")
  const [currentAnnonce, setCurrentAnnonce] = useState<Annonce | null>(null)
  const [isModalOpen2, setIsModalOpen2] = useState<boolean>(false)

  // Admin reminder modal states
  const [isAdminReminderModalOpen, setIsAdminReminderModalOpen] = useState<boolean>(false)
  const [currentAnnonceForAdminReminder, setCurrentAnnonceForAdminReminder] = useState<Annonce | null>(null)
  const [activeTab, setActiveTab] = useState<"liste" | "plafonds">("liste");

  const [emailModal, setEmailModal] = useState<{
    isOpen: boolean;
    recipientName: string;
    recipientEmail: string;
    annonce: Annonce | null;
  }>({
    isOpen: false,
    recipientName: '',
    recipientEmail: '',
    annonce: null
  });

  const handleOpenEmailModal = (annonce: Annonce) => {
  setEmailModal({
    isOpen: true,
    recipientName: `${annonce.firstname} ${annonce.name || ''}`.trim() || 'Client',
    recipientEmail: annonce.email,
    annonce: annonce
  });
  setShowMenu(null); 
};

  type FilterType = "all" | "paid" | "unpaid"

  const labels: Record<FilterType, string> = {
    all: "Toutes les annonces",
    paid: "Annonces Payées",
    unpaid: "Annonces Non payées",
  }

  const handleClickReminder = (annonce: Annonce) => {
    // garde pour EmailReminderModal si besoin ailleurs
    setCurrentAnnonce(annonce)
    setIsModalOpen2(true)
  }

  const handleClickAdminReminder = (annonce: Annonce) => {
    setCurrentAnnonceForAdminReminder(annonce)
    setIsAdminReminderModalOpen(true)
  }

  const [isTodayFilterActive, setIsTodayFilterActive] = useState<boolean>(false)

  const getAnnonce = async (annonceId: string): Promise<void> => {
    await axios(`/annonce/id/${annonceId}`)
      .then((response) => {
        const annonceTemp = response.data.annonce
        setAnnonce(annonceTemp)
      })
      .catch((error) => console.log(error))
  }

  const handleAnnonceDetail = (annonce: Annonce): void => {
    setAnnonceNow(annonce)
    setModalIsOpen(true)
  }

  const showModal = (): void => {
    setIsModalOpen(true)
  }

  const handleOpenUpdate = (annonce: Annonce): void => {
    setCurrentAnnonceId(annonce.annonce_id)
    getAnnonce(annonce.annonce_id.toString())
    showModal()
  }

  const handleOpenAvoirModal = (annonce: Annonce): void => {
    setSelectedAnnonceForAvoir(annonce)
    setAvoirModalIsOpen(true)
  }

  const handleCloseAvoirModal = (): void => {
    if (!avoirLoading) {
      setAvoirModalIsOpen(false)
      setSelectedAnnonceForAvoir(null)
      setAvoirMontant("")
    }
  }

  const handleAdminReminderSuccess = async () => {
    await fetchAnnonces();
  };

  //Pour le type

  const fetchAnnonces = async (): Promise<void> => {
    setLoading(true)
    try {
      const fetchedAnnonces = await getAllAnnoncesUser()
      if (fetchedAnnonces) setAnnonces(fetchedAnnonces)
    } catch (error) {
      console.error('[ANNONCES] Erreur fetch:', error)
      setError("Erreur lors de la récupération des données")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAnnonces()
  }, [])

  const handleAvoirSubmit = async (): Promise<void> => {
    if (!selectedAnnonceForAvoir || !avoirMontant.trim()) {
      toast.error("Veuillez saisir un montant valide")
      return
    }

    const montant = parseFloat(avoirMontant)
    if (isNaN(montant) || montant <= 0) {
      toast.error("Le montant doit être un nombre positif")
      return
    }

    setAvoirLoading(true)

    try {
      const annonceId = selectedAnnonceForAvoir.id || selectedAnnonceForAvoir.annonce_id

      if (!annonceId) {
        toast.error("ID d'annonce introuvable")
        return
      }

      await createAvoir({
        annonce_id: annonceId,
        montant_avoir: montant,
        statut: "pending",
      })

      toast.success("Avoir créé avec succès")

      setTimeout(async () => {
        await fetchAnnonces()
      }, 500)

      handleCloseAvoirModal()
    } catch (error: any) {
      console.error('[AVOIR] Erreur création:', error)
      toast.error(error?.message || "Erreur lors de la création de l'avoir")
    } finally {
      setAvoirLoading(false)
    }
  }

  const [confirmModal, setConfirmModal] = useState<{
    annonce: Annonce | undefined
    type: undefined | "justif" | "alo"
    isOpen: boolean
    loading: boolean
    email: string
  }>({
    annonce: undefined,
    type: undefined,
    isOpen: false,
    loading: false,
    email: "",
  })

  const [showMenu, setShowMenu] = useState<number | null>(null)
  const menuRef = useRef<HTMLDivElement | null>(null)

  const toggleMenu = (index: number): void => {
    setShowMenu(index === showMenu ? null : index)
  }

  const handleClickOutsideDropDownMenu = (event: MouseEvent): void => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setShowMenu(null)
    }
  }

  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideDropDownMenu)
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropDownMenu)
    }
  }, [])

  const handleClickSendAttestation = (annonce: Annonce): void => {
    setConfirmModal((prev) => ({
      ...prev,
      type: "alo",
      annonce,
      isOpen: true,
      email: annonce.email,
    }))
  }

  const handleClickSendJustif = (annonce: Annonce): void => {
    setConfirmModal((prev) => ({
      ...prev,
      type: "justif",
      annonce,
      isOpen: true,
      email: annonce.email,
    }))
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setConfirmModal((prev) => ({
      ...prev,
      email: e.target.value,
    }))
  }

  const handleConfirmLegale = async (): Promise<void> => {
    setConfirmModal((prev) => ({ ...prev, type: "alo", loading: true }))
    try {
      const response = await sendAttestationAloByEmail({
        email: confirmModal.email,
        attestationAlo: confirmModal.annonce?.pdfAttestation.split("-").join("-ALO-"),
      })
      setConfirmModal((prev) => ({
        ...prev,
        type: "alo",
        isOpen: false,
        loading: false,
      }))
      toast.success(response?.message)
    } catch (error: any) {
      toast.error(error?.message || "Erreur lors de l'envoi")
    } finally {
      setConfirmModal((prev) => ({ ...prev, loading: false }))
    }
  }

  const handleConfirmJustif = async (): Promise<void> => {
    setConfirmModal((prev) => ({ ...prev, type: "justif", loading: true }))
    try {
      const response = await sendJustifByEmail({
        email: confirmModal.email,
        annonceId: confirmModal.annonce?.annonce_id,
      })
      setConfirmModal((prev) => ({
        ...prev,
        type: "justif",
        isOpen: false,
        loading: false,
      }))
      toast.success(response?.message)
    } catch (error: any) {
      toast.error(error?.message || "Erreur lors de l'envoi")
    } finally {
      setConfirmModal((prev) => ({ ...prev, loading: false }))
    }
  }

  const handleCloseConfirmModal = (): void => {
    if (!confirmModal.loading) {
      setConfirmModal((prev) => ({
        ...prev,
        isOpen: false,
        email: "",
      }))
    }
  }

  const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchText(e.target.value)
  }

  const handleSearchSupportChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchSupport(e.target.value)
  }

  const handleSearchClientChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchClient(e.target.value)
  }

  const formatDate = (date: Date | string): string => {
    const d = new Date(date)
    if (isNaN(d.getTime())) {
      return "Date invalide"
    }
    const day = String(d.getDate()).padStart(2, "0")
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const year = d.getFullYear()
    return `${day}.${month}.${year}`
  }

  const handleCloseDetail = (): void => {
    setModalIsOpen(false)
    setAnnonceNow(null)
  }

  const filteredAnnonces = annonces.filter((annonce) => {
    const searchTextLower = searchText.toLowerCase()
    const searchSupportLower = searchSupport.toLowerCase()
    const searchClientLower = searchClient.toLowerCase()

    const dossierAnnonceMatch =
      annonce.numDossier.toLowerCase().includes(searchTextLower) ||
      annonce.numAnnonce.toLowerCase().includes(searchTextLower) ||
      annonce.reference.toLowerCase().includes(searchTextLower) ||
      annonce.type_annonce.toLowerCase().includes(searchTextLower)

    const supportMatch = annonce.nomJal.toLowerCase().includes(searchSupportLower)

    const clientMatch =
      annonce.firstname.toLowerCase().includes(searchClientLower) ||
      annonce.email.toLowerCase().includes(searchClientLower) ||
      annonce.reference.toLowerCase().includes(searchClientLower)

    const annonceDateObj = new Date(annonce.createdAt)
    if (isNaN(annonceDateObj.getTime())) return false

    let start: Date | null = null
    let end: Date | null = null

    if (startDate) {
      const tempStart = new Date(startDate)
      if (!isNaN(tempStart.getTime())) {
        start = tempStart
        start.setHours(0, 0, 0, 0)
      }
    }

    if (endDate) {
      const tempEnd = new Date(endDate)
      if (!isNaN(tempEnd.getTime())) {
        end = tempEnd
        end.setHours(23, 59, 59, 999)
      }
    }

    const annonceTime = annonceDateObj.getTime()
    const dateMatch =
      (!start || annonceTime >= start.getTime()) &&
      (!end || annonceTime <= end.getTime())

    return dossierAnnonceMatch && supportMatch && clientMatch && dateMatch
  })

  const filteredByPayment = filteredAnnonces.filter((annonce) => {
    if (filterPaid === "paid") return Boolean(annonce.isPaid)
    if (filterPaid === "unpaid") return !annonce.isPaid
    return true
  })

  const { paginatedData: paginatedAnnonces, totalPages } = paginate(
    filteredByPayment.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
    currentPage,
    ITEMS_PER_PAGE
  )

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const todayEnd = new Date(today)
  todayEnd.setHours(23, 59, 59, 999)

  const annoncesDuJour = filteredAnnonces.filter((annonce) => {
    const annonceDate = new Date(annonce.createdAt)
    return annonceDate >= today && annonceDate <= todayEnd
  })

  if (loading) {
    return <LoaderAnnonce />
  }

  return (
    <>
      <EmailReminderModal
        isModalOpen={isModalOpen2}
        setIsModalOpen={setIsModalOpen2}
        currentAnnonce={currentAnnonce}
        setCurrentAnnonce={setCurrentAnnonce}
      />

      <AdminReminderModal
        visible={isAdminReminderModalOpen}
        onClose={() => {
          setIsAdminReminderModalOpen(false);
          setCurrentAnnonceForAdminReminder(null);
        }}
        currentAnnonce={currentAnnonceForAdminReminder}
        onSuccess={handleAdminReminderSuccess}
      />

      <UpdateAnnonce isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} annonce={annonce} setAnnonce={setAnnonce} />
      <div className="la-liste-annonces-container container-fluid px-3">
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "liste" ? "active" : ""}`}
              role="button"
              onClick={() => setActiveTab("liste")}
            >
              <FaListAlt className="me-2" /> Liste des annonces
            </a>
          </li>
          {/* <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "plafonds" ? "active" : ""}`}
              role="button"
              onClick={() => setActiveTab("plafonds")}
            >
              <FaCalculator className="me-2" /> Gestion des plafonds
            </a>
          </li> */}
        </ul>
        {activeTab === "liste" && (
          <>
            <div className="mb-3 d-flex align-items-center gap-3 flex-wrap" style={{ justifyContent: "flex-start" }}>
              <div style={{ position: "relative" }}>
                <span
                  title="Cliquer pour filtrer par statut de paiement"
                  className="badge"
                  style={{
                    padding: "12px 20px",
                    fontSize: "15px",
                    backgroundColor: "white",
                    border: "1px solid #4BB0C0",
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "all 0.3s",
                    color: "#4BB0C0",
                  }}
                  onClick={() => setShowFilterMenu(!showFilterMenu)}
                >
                  Filtrer les annonces
                </span>

                {showFilterMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50px",
                      left: "0",
                      background: "#fff",
                      borderRadius: "10px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                      width: "220px",
                      zIndex: 10,
                      overflow: "hidden",
                    }}
                  >
                    {(Object.keys(labels) as FilterType[]).map((type) => (
                      <div
                        key={type}
                        onClick={() => {
                          setFilterPaid(type)
                          setShowFilterMenu(false)
                        }}
                        style={{
                          padding: "12px 16px",
                          cursor: "pointer",
                          transition: "background 0.2s, color 0.2s",
                          color: filterPaid === type ? "#4BB0C0" : "#333",
                          backgroundColor: filterPaid === type ? "#E0F7FA" : "#fff",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = filterPaid === type ? "#E0F7FA" : "#fff")
                        }
                      >
                        {labels[type]}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <span
                className="badge"
                style={{
                  padding: "12px 20px",
                  fontSize: "15px",
                  backgroundColor: "#F4A261",
                  borderRadius: "8px",
                  color: "#fff",
                }}
              >
                Nombre d'annonces | {filteredAnnonces.length}
              </span>

              <span
                className="badge"
                style={{
                  padding: "12px 20px",
                  fontSize: "15px",
                  backgroundColor: "#4BB0C0",
                  borderRadius: "8px",
                  color: "#fff",
                }}
              >
                Annonces du jour | {annoncesDuJour.length}
              </span>

              <span
                className="badge"
                style={{
                  backgroundColor: isTodayFilterActive ? "#4BB0C0" : "white",
                  color: isTodayFilterActive ? "#fff" : "#333",
                  border: "1px solid #4BB0C0",
                  padding: "12px 20px",
                  fontSize: "15px",
                  cursor: "pointer",
                  borderRadius: "8px",
                  transition: "all 0.3s",
                }}
                onClick={() => {
                  if (!isTodayFilterActive) {
                    const yyyy = today.getFullYear()
                    const mm = String(today.getMonth() + 1).padStart(2, "0")
                    const dd = String(today.getDate()).padStart(2, "0")
                    const formattedDate = `${yyyy}-${mm}-${dd}`
                    setStartDate(formattedDate)
                    setIsTodayFilterActive(true)
                  } else {
                    setStartDate("")
                    setEndDate("")
                    setIsTodayFilterActive(false)
                  }
                }}
              >
                {isTodayFilterActive ? "Voir toutes les annonces" : "Afficher les annonces du jour"}
              </span>
            </div>
            <div className="row g-3 mb-4 pb-2">
              <div className="col-12 col-md-6 col-lg-4">
                <div className="la-search-group">
                  <label htmlFor="start-date">Date début</label>
                  <DatePicker
                    id="start-date"
                    value={startDate ? dayjs(startDate) : null}
                    onChange={(date) => setStartDate(date ? date.format("YYYY-MM-DD") : null)}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="la-search-group">
                  <label htmlFor="end-date">Date fin</label>
                  <DatePicker
                    id="end-date"
                    value={endDate ? dayjs(endDate) : null}
                    onChange={(date) => setEndDate(date ? date.format("YYYY-MM-DD") : null)}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="la-search-group">
                  <label htmlFor="search-client">Client</label>
                  <input id="search-client" type="text" className="form-control la-search-input" value={searchClient} onChange={handleSearchClientChange} />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="la-search-group">
                  <label htmlFor="search-dossier-annonce">Dossier ou Type d'annonce</label>
                  <input id="search-dossier-annonce" type="text" className="form-control la-search-input" value={searchText} onChange={handleSearchTextChange} />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="la-search-group">
                  <label htmlFor="search-support">Support</label>
                  <input id="search-support" type="text" className="form-control la-search-input" value={searchSupport} onChange={handleSearchSupportChange} />
                </div>
              </div>
            </div>

            {/* {console.log(paginatedAnnonces.map(a => a.User?.user_type))} */}
            <div
              id="right_panel"
              className="la-table-wrapper-no-padding table-responsive d-none d-md-block"
              style={{ overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <table className="table la-wrap-table table-hover">
                <thead className="la-sticky-t-0">
                  <tr>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "13%" }}>
                      Client
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "13%" }}>
                      Dossier
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "13%" }}>
                      Annonce
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "13%" }}>
                      Type
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "10%" }}>
                      Montant TTC
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "10%" }}>
                      Avoir
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "11%" }}>
                      Support
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "12%" }}>
                      Parution
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "22%" }}>
                      Statut<br />de paiement
                    </th>
                    <th scope="col" className="text-nowrap la-sticky-t-0 text-center" style={{ width: "12%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedAnnonces
                    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                    .map((annonce, index) => {
                      return (
                        <tr key={index}>
                          <td className="text-center">
                            <div className="la-table-truncate" title={annonce.firstname}>
                              {annonce.firstname}
                            </div>
                            <div className="la-table-truncate" title={annonce.email}>
                              {annonce.email}
                            </div>
                            <div className="la-table-truncate" title={annonce.reference}>
                              {annonce.reference}
                            </div>
                          </td>

                          <td className="text-center">
                            <div className="la-table-truncate" title={annonce.numDossier}>
                              {annonce.numDossier}
                            </div>
                            <div className="la-table-truncate" title={`Du ${formatDate(new Date(annonce.createdAt))}`}>
                              {`Du ${formatDate(new Date(annonce.createdAt))}`}
                            </div>
                          </td>

                          <td className="text-center">
                            <div className="la-table-truncate" title="Ma société">
                              Ma société
                            </div>
                            <div className="la-table-truncate" title={annonce.numAnnonce}>
                              {annonce.numAnnonce}
                            </div>
                            <div
                              className="la-table-truncate"
                              style={{
                                background:
                                  annonce.User?.user_type === 'entreprise' ? '#2A919D' :
                                    annonce.User?.user_type === 'professionnel' ? '#F4A261' :
                                      '#4BB0C0',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontWeight: '500'
                              }}
                              title={
                                annonce.User?.user_type === 'personne' ? 'Particulier' :
                                  annonce.User?.user_type === 'entreprise' ? 'Entreprise' :
                                    annonce.User?.user_type === 'professionnel' ? 'Professionnel' :
                                      'N/A'
                              }
                            >
                              {annonce.User?.user_type === 'personne' ? 'Particulier' :
                                annonce.User?.user_type === 'entreprise' ? 'Entreprise' :
                                  annonce.User?.user_type === 'professionnel' ? 'Professionnel' :
                                    'N/A'}
                            </div>
                          </td>

                          <td className="text-center">
                            <div className="la-table-truncate" title={annonce.type_annonce}>
                              {annonce.type_annonce}
                            </div>
                          </td>

                          <td className="text-nowrap">{annonce.montantTTC} €</td>

                          <td className="text-center">
                            {(() => {
                              const avoirsPending = annonce.avoirs?.filter(avoir => avoir.statut === "pending") || [];
                              const totalPending = avoirsPending.reduce((sum, avoir) => sum + Number(avoir.montant_avoir || 0), 0);

                              if (totalPending > 0) {
                                return <div>{totalPending.toFixed(2)} €</div>;
                              }

                              return <div className="text-muted">—</div>;
                            })()}
                          </td>

                          <td className="text-center">
                            <div className="la-table-truncate" title={annonce.nomJal}>
                              {annonce.nomJal}
                            </div>
                          </td>

                          <td className="text-nowrap">{`le ${formatDate(new Date(annonce.dateParrution))}`}</td>

                          {/* Statut de paiement : affichage admin-only */}
                          <td className="text-center" style={{ minWidth: "200px", padding: "8px 4px" }}>
                            <div className="la-table-truncate">
                              {annonce.isPaid ? (
                                <FaCheckCircle style={{ color: 'green' }} title="Payé" />
                              ) : (
                                <Popover
                                  content={
                                    <div>
                                      <div>Relancer client + utilisateur</div>
                                      {(annonce?.reminderCount ?? 0) > 0 && (
                                        <small style={{ color: '#999', display: 'block', marginTop: '4px' }}>
                                          {annonce.reminderCount ?? 0} relance(s) envoyée(s)
                                          {annonce.lastReminderDate && (
                                            <div style={{ fontSize: '10px', marginTop: '2px' }}>
                                              Dernière: {new Date(annonce.lastReminderDate).toLocaleString('fr-FR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                              })}
                                            </div>
                                          )}
                                        </small>
                                      )}
                                    </div>
                                  }
                                  trigger="hover"
                                >
                                  <Button
                                    onClick={() => handleClickAdminReminder(annonce)}
                                    style={{
                                      background: '#eb8635',
                                      border: 'none',
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '10px',
                                      padding: '10px 13px',
                                      height: 'auto',
                                      width: '100%',
                                      whiteSpace: 'normal',
                                      borderRadius: '6px'
                                    }}
                                  >
                                    {/* Contenu central : Compteur, texte et date */}
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '4px',
                                        flex: 1
                                      }}
                                    >
                                      {/* Ligne 1 : Compteur et Texte "Non payé" */}
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '6px'
                                        }}
                                      >
                                        {/* Badge circulaire avec compteur */}
                                        {(annonce?.reminderCount ?? 0) > 0 && (
                                          <span
                                            style={{
                                              backgroundColor: '#fff',
                                              color: '#eb8635',
                                              borderRadius: '50%',
                                              width: '22px',
                                              height: '22px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: '11px',
                                              fontWeight: 'bold',
                                              flexShrink: 0
                                            }}
                                            title={`${annonce.reminderCount ?? 0} relance(s) envoyée(s)`}
                                          >
                                            {annonce.reminderCount}
                                          </span>
                                        )}

                                        {/* Texte "Non payé" */}
                                        <span
                                          style={{
                                            color: '#FFF',
                                            fontWeight: 'bold',
                                            fontSize: '15px'
                                          }}
                                        >
                                          Non payé
                                        </span>
                                      </div>

                                      {/* Ligne 2 : Date de dernière relance */}
                                      {(annonce?.reminderCount ?? 0) > 0 && annonce.lastReminderDate && (
                                        <span
                                          style={{
                                            fontSize: '15px',
                                            color: '#FFF',
                                            opacity: 0.85,
                                            textAlign: 'center',
                                            lineHeight: '1.2'
                                          }}
                                          title={`Dernière relance : ${new Date(annonce.lastReminderDate).toLocaleString('fr-FR')}`}
                                        >
                                          {new Date(annonce.lastReminderDate).toLocaleDateString('fr-FR')}{' '}
                                          {/* {new Date(annonce.lastReminderDate).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })} */}
                                        </span>
                                      )}
                                    </div>

                                    {/* Icône d'envoi à droite */}
                                    <FontAwesomeIcon
                                      title="Relancer paiement (admin)"
                                      className="la-cursor-pointer"
                                      color="#FFF"
                                      icon={faPaperPlane}
                                      style={{
                                        fontSize: '16px',
                                        flexShrink: 0
                                      }}
                                    />
                                  </Button>

                                </Popover>
                              )}
                            </div>
                          </td>

                          <td style={{ overflow: "initial !important" }}>
                            <div className="d-flex justify-content-around align-items-center">
                              <FontAwesomeIcon
                                title="Modifier l'annonce"
                                className="la-cursor-pointer"
                                color="#F4A261"
                                icon={faEdit}
                                onClick={() => handleOpenUpdate(annonce)}
                              />

                              <FontAwesomeIcon
                                title="Details de l'annonce"
                                className="la-cursor-pointer"
                                color="#F4A261"
                                icon={faFile}
                                onClick={() => handleAnnonceDetail(annonce)}
                              />
                              {(!annonce.avoirs ||
                                annonce.avoirs.length === 0 ||
                                !annonce.avoirs.some(avoir => avoir.statut === 'pending')
                              ) && (
                                  <FontAwesomeIcon
                                    title="Ajouter un avoir"
                                    className="la-cursor-pointer"
                                    color="#F4A261"
                                    icon={faPlus}
                                    onClick={() => handleOpenAvoirModal(annonce)}
                                  />
                                )}

                         
                      <div className="la-dropdown-container" ref={showMenu === index ? menuRef : null}>
                                  <FontAwesomeIcon
                                    title={`Envoyer l'attestation legale ou pdf justificatif ${annonce.email}`}
                                    className="la-cursor-pointer"
                                    color="#F4A261"
                                    icon={faEllipsisV}
                                    onClick={() => toggleMenu(index)}
                                  />
                                  
                                  {showMenu === index && (
                                    <div className="la-menu-dropdown">
                                      {/* Option pour envoyer l'attestation ALO (toujours visible) */}
                                      <div
                                        onClick={() => {
                                          handleClickSendAttestation(annonce);
                                          setShowMenu(null);
                                        }}
                                        className="la-action-button"
                                      >
                                        Envoyer l'attestation ALO
                                      </div>

                                      {/* Option pour envoyer un email personnalisé */}
                                      <div
                                        onClick={() => handleOpenEmailModal(annonce)}
                                        className="la-action-button"
                                      >
                                        Envoyer un email personnalisé
                                      </div>
                                      
                                      {/* Options conditionnelles si le PDF justificatif existe */}
                                      {annonce?.pdf_justif_lien_public && (
                                        <>
                                          <div
                                            onClick={() => {
                                              handleClickSendAttestation(annonce);
                                              setShowMenu(null);
                                            }}
                                            className="la-action-button"
                                          >
                                            Envoyer l'attestation légale
                                          </div>
                                          <div
                                            onClick={() => {
                                              handleClickSendJustif(annonce);
                                              setShowMenu(null);
                                            }}
                                            className="la-action-button"
                                          >
                                            Envoyer le fichier PDF Justificatif
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </div>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="d-block d-md-none">
              {paginatedAnnonces
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                .map((annonce, index) => (
                  <div key={index} className="card mb-3 la-mobile-card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-6">
                          <strong>Client:</strong><br />
                          {annonce.firstname}<br />
                          {annonce.email}<br />
                          {annonce.reference}
                        </div>
                        <div className="col-6 text-end">
                          <strong>Dossier:</strong><br />
                          {annonce.numDossier}<br />
                          Du {formatDate(new Date(annonce.createdAt))}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-6">
                          <strong>Annonce:</strong><br />
                          Ma société<br />
                          {annonce.numAnnonce}<br />
                          <span
                            style={{
                              background:
                                annonce.User?.user_type === 'entreprise' ? '#2A919D' :
                                  annonce.User?.user_type === 'professionnel' ? '#F4A261' :
                                    '#4BB0C0',
                              color: 'white',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}
                          >
                            {annonce.User?.user_type === 'personne' ? 'Particulier' :
                              annonce.User?.user_type === 'entreprise' ? 'Entreprise' :
                                annonce.User?.user_type === 'professionnel' ? 'Professionnel' :
                                  'N/A'}
                          </span>
                        </div>
                        <div className="col-6 text-end">
                          <strong>Type:</strong> {annonce.type_annonce}<br />
                          <strong>Montant TTC:</strong> {annonce.montantTTC} €<br />
                          <strong>Avoir:</strong> {(() => {
                            const avoirsPending = annonce.avoirs?.filter(avoir => avoir.statut === "pending") || [];
                            const totalPending = avoirsPending.reduce((sum, avoir) => sum + Number(avoir.montant_avoir || 0), 0);
                            return totalPending > 0 ? `${totalPending.toFixed(2)} €` : '—';
                          })()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-6">
                          <strong>Support:</strong> {annonce.nomJal}<br />
                          <strong>Parution:</strong> le {formatDate(new Date(annonce.dateParrution))}
                        </div>
                        <div className="col-6 text-end">
                          <strong>Statut:</strong><br />
                          {annonce.isPaid ? (
                            <FaCheckCircle style={{ color: 'green' }} />
                          ) : (
                            <button
                              onClick={() => handleClickAdminReminder(annonce)}
                              style={{
                                background: '#eb8635',
                                border: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '5px 8px',
                                fontSize: '12px',
                                color: '#fff',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title={`Relancer paiement - ${annonce?.reminderCount ?? 0} relance(s)`}
                            >
                              {(annonce?.reminderCount ?? 0) > 0 && (
                                <span
                                  style={{
                                    backgroundColor: '#fff',
                                    color: '#eb8635',
                                    borderRadius: '50%',
                                    width: '16px',
                                    height: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {annonce.reminderCount}
                                </span>
                              )}
                              Non payé
                              <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: '10px' }} />
                            </button>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-around">
                        <FontAwesomeIcon
                          title="Modifier l'annonce"
                          className="la-cursor-pointer"
                          color="#F4A261"
                          icon={faEdit}
                          onClick={() => handleOpenUpdate(annonce)}
                        />
                        <FontAwesomeIcon
                          title="Details de l'annonce"
                          className="la-cursor-pointer"
                          color="#F4A261"
                          icon={faFile}
                          onClick={() => handleAnnonceDetail(annonce)}
                        />
                        {(!annonce.avoirs ||
                          annonce.avoirs.length === 0 ||
                          !annonce.avoirs.some(avoir => avoir.statut === 'pending')
                        ) && (
                            <FontAwesomeIcon
                              title="Ajouter un avoir"
                              className="la-cursor-pointer"
                              color="#F4A261"
                              icon={faPlus}
                              onClick={() => handleOpenAvoirModal(annonce)}
                            />
                          )}
                        {annonce?.pdf_justif_lien_public ? (
                          <div className="la-dropdown-container">
                            <FontAwesomeIcon
                              title={`Envoyer l'attestation legale ou pdf justificatif ${annonce.email}`}
                              className="la-cursor-pointer"
                              color="#F4A261"
                              icon={faEllipsisV}
                              onClick={() => toggleMenu(index)}
                            />
                            {showMenu === index && (
                              <div className="la-menu-dropdown">
                                <div
                                  onClick={() => {
                                    handleClickSendAttestation(annonce)
                                    setShowMenu(null)
                                  }}
                                  className="la-action-button"
                                >
                                  Envoyer l'attestation legale
                                </div>
                                <div
                                  onClick={() => {
                                    handleClickSendJustif(annonce)
                                    setShowMenu(null)
                                  }}
                                  className="la-action-button"
                                >
                                  Envoyer le fichier PDF Justificatif
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <FontAwesomeIcon
                            title={`Envoyer l'attestation ALO ${annonce.email}`}
                            className="la-cursor-pointer"
                            color="#F4A261"
                            icon={faPaperPlane}
                            onClick={() => handleClickSendAttestation(annonce)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </div>
            )}

          </>)}
        <Modal
          isOpen={avoirModalIsOpen}
          onRequestClose={handleCloseAvoirModal}
          contentLabel="Ajouter un avoir"
          overlayClassName="la-modal-overlay"
          className="la-modal-content"
          style={{
            content: {
              maxWidth: "500px",
              maxHeight: "400px",
              margin: "auto",
              padding: "0",
              border: "none",
              borderRadius: "8px",
            },
          }}
        >
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="modal-title mb-0"> Ajouter un avoir </h5>
            <button
              type="button"
              className="btn-close border-0 bg-transparent"
              onClick={handleCloseAvoirModal}
              disabled={avoirLoading}
              aria-label="Fermer"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="p-3">
            {selectedAnnonceForAvoir && (
              <div className="mb-3">
                <p className="mb-2">
                  <strong>Client:</strong> {selectedAnnonceForAvoir.firstname}
                </p>
                <p className="mb-2">
                  <strong>Annonce:</strong> {selectedAnnonceForAvoir.numAnnonce}
                </p>
              </div>
            )}
            <div className="mb-3">
              <label htmlFor="montant-avoir" className="form-label">
                Montant de l'avoir (€) :
              </label>
              <input
                id="montant-avoir"
                type="number"
                step="0.01"
                min="0"
                className="form-control"
                value={avoirMontant}
                onChange={(e) => setAvoirMontant(e.target.value)}
                disabled={avoirLoading}
                placeholder="Ex: 125.50"
              />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 p-3 border-top">
            <button type="button" className="btn btn-secondary" onClick={handleCloseAvoirModal} disabled={avoirLoading}>
              Annuler
            </button>
            <button
              type="button"
              className="btn btn-success d-flex align-items-center gap-2"
              onClick={handleAvoirSubmit}
              disabled={avoirLoading || !avoirMontant.trim()}
            >
              {avoirLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Création...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faPlus} />
                  Créer l'avoir
                </>
              )}
            </button>
          </div>
        </Modal>

        {annonceNow && (
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseDetail}
            contentLabel="Annonce Detail"
            overlayClassName="modal-overlay"
            className="modal-content la-announcement-detail-modal py-4"
            style={{
              content: {
                zIndex: 9999,
              },
            }}
          >
            <AnnonceDetailsAdmin annonceNow={annonceNow} closeModal={handleCloseDetail} />
            <div style={{ display: "flex", justifyContent: "center", background: "#ffffff", marginBottom: "-25px" }}>
              <button
                className="btn btn-secondary"
                onClick={handleCloseDetail}
                style={{ backgroundColor: '#F4A261', border: 'none', marginTop: '-10px', marginBottom: '10px' }}
              >
                Fermer
              </button>
            </div>
          </Modal>
        )}

        <Modal
          isOpen={Boolean(confirmModal.annonce) && Boolean(confirmModal.type) && confirmModal.isOpen}
          onRequestClose={() => { }}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Confirmation Email"
          overlayClassName="la-modal-overlay"
          className="la-modal-content"
          style={{
            content: {
              maxWidth: "500px",
              maxHeight: "600px",
              margin: "auto",
              padding: "0",
              border: "none",
              borderRadius: "8px",
            },
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="modal-title mb-0">{`Confirmation de l'envoi ${confirmModal.type === "alo" ? "de l'attestation legale" : "du pdf justificatif"}`}</h5>
            <button
              type="button"
              className="btn-close border-0 bg-transparent"
              onClick={handleCloseConfirmModal}
              disabled={confirmModal.loading}
              aria-label="Fermer"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="p-3">
            <p className="mb-3">Vous voulez envoyer {confirmModal.type === "alo" ? "l'attestation de ALO" : "le pdf justificatif"} ?</p>
            <div className="mb-3">
              <label htmlFor="email-input" className="form-label">
                Adresse email :
              </label>
              <input id="email-input" type="email" className="form-control" value={confirmModal.email} onChange={handleEmailChange} disabled={confirmModal.loading} placeholder="Entrez l'adresse email" />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 p-3">
            <button type="button" className="btn btn-secondary" onClick={handleCloseConfirmModal} disabled={confirmModal.loading}>
              Annuler
            </button>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => (confirmModal.type === "alo" ? handleConfirmLegale() : handleConfirmJustif())}
              disabled={confirmModal.loading || !confirmModal.email.trim()}
              style={{ backgroundColor: "#F4A261", border: "none" }}
            >
              {confirmModal.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Envoi...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faEnvelope} />
                  Confirmer
                </>
              )}
            </button>
          </div>
        </Modal>
        {/* {activeTab === "plafonds" && (
        <div>
          <UserLimitCards userRole="ADMIN" />
        </div>
      )} */}

        <EmailModal
          show={emailModal.isOpen}
          onClose={() => setEmailModal(prev => ({ ...prev, isOpen: false }))}
          recipientName={emailModal.recipientName}
          recipientEmail={emailModal.recipientEmail}
          currentUserEmail={localStorage.getItem('userEmail') || ''}
          fromUserListPoint={false}
        />

        <ToastContainer />
      </div>
    </>
  )
}

export default ListesAnnonces
